import type { PropsWithoutRef, SVGProps } from "react";

const SHARE_FILL = "var(--color-brand-primary)";

export default function ShareIcon({ ...props }: PropsWithoutRef<SVGProps<SVGElement>>) {
	return (
		<svg
			width="22"
			height="20"
			viewBox="0 0 22 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M21.643 7.04624L14.0803 0.261201C13.4183 -0.332772 12.375 0.149415 12.375 1.07209V4.64588C5.47297 4.72798 0 6.16517 0 12.961C0 15.7039 1.70075 18.4212 3.58072 19.8418C4.16737 20.2852 5.00345 19.7288 4.78715 19.0101C2.83877 12.5363 5.71128 10.8177 12.375 10.7181V14.6428C12.375 15.5669 13.4191 16.047 14.0803 15.4537L21.643 8.66802C22.1187 8.24115 22.1193 7.47369 21.643 7.04624Z"
				fill={SHARE_FILL}
			/>
		</svg>
	);
}
